import React, {useEffect, useState} from "react";
import {formatTime, formatTimeExtended} from "../../common/utils/date-format.ts";


type Props = {
    startCount: number, // 倒计时的秒数
    onTick: (count: number) => void, // 每倒计时一秒进行的操作
    onCountdownEnd?: () => void, // 倒计时结束后的操作
    interval: number,
    className?: string,
    showHours?: boolean, // 是否显示小时

}

const Countdown: React.FC<Props> = ({startCount, onTick, onCountdownEnd, interval, className, showHours}) => {
    const [count, setCount] = useState<number>(0);

    useEffect(() => {
        setCount(startCount)
    }, [startCount]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCount((prevTime: number) => {
                if (prevTime <= 0) {
                    if (onCountdownEnd) {
                        onCountdownEnd();
                    }
                    clearInterval(interval);
                    return prevTime;
                } else {
                    onTick(prevTime - 1);
                    return prevTime - 1;
                }

            });
        }, interval);

        return () => clearInterval(intervalId);
    }, [startCount, onTick, interval]);

    return <div className={`countdown ${className}`}>{showHours ? formatTimeExtended(count) : formatTime(count)}</div>;
};

export default Countdown;